import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkupProfileAction } from '../markupProfile.action';

type IDependencies = IClientApiDependencySegment;

export const createMarkupProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(MarkupProfileAction.create.started),
  mergeMap((params) => {
    const { payload, resolve } = params;

    return dependencies.api.createMarkupProfile({ name: payload.markupProfileName }).pipe(
      mergeMap((result) => {
        resolve(result.id);

        return [
          MarkupProfileAction.create.done({ params, result: { profileId: result.id } }),
        ];
      }),
      catchApiError((error) => {
        return [
          MarkupProfileAction.create.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
